// La jauge de bien-être, avec le palier en cours et son effet.
import { t } from '../engine/i18n';
import type { GameState } from '../engine/state';
import { currentMood } from '../game/wellbeing';
import { Meter } from './components';

export function WellbeingGauge({ state }: { state: GameState }) {
  const mood = currentMood(state);
  const tone = mood.id === 'forme' ? 'tone-good' : mood.id === 'normal' ? 'muted' : 'warning';
  return (
    <>
      <p class="meter-label">
        {t('dash.wellbeing')}
        <span>
          {Math.round(state.wellbeing)} · {t(mood.label)}
        </span>
      </p>
      <Meter value={state.wellbeing} max={100} tone="wellbeing" label={t('dash.wellbeing')} />
      <p class={`mood ${tone}`}>{t('dash.mood', { label: t(mood.label), effect: t(mood.effect) })}</p>
    </>
  );
}
